/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios'
import { message } from 'ant-design-vue'
import  i18n  from '../i18n'
const t = i18n.global.t
const locale = i18n.global.locale

// 创建axios实例
const instance = axios.create({
    baseURL: process.env.VUE_APP_API ? process.env.VUE_APP_API : '',
    headers: {
        'Content-Type': 'application/json',
        'Cbim-lang': locale
    }
})

const toLogin = () => {
    console.log('请登录')
}

const errorHandle = (status: number) => {
    switch (status) {
        case 401:
            toLogin()
            break
        case 403:
            message.warning(t('message.dengluguoqi'))
            setTimeout(() => {
                toLogin()
            }, 2000)
            break
        case 404:
            message.error(t('message.qingqiulujingcuowu'))
            break
        case 500:
            message.error(t('message.fuwuqifashengcuowu'))
            break
        default:
            message.error(t('message.qingqiuyichang'))
            break
    }
}
// 添加请求拦截器
instance.interceptors.request.use(
    // 在发送请求之前做些什么
    config => config,
    // 对请求错误做些什么
    error => Promise.reject(error)
)

// 添加响应拦截器
instance.interceptors.response.use(
    // 对响应数据做点什么
    response => {
        if (response.status === 200) {
            return response.data
        }
    },
    // 对响应错误做点什么
    error => {
        errorHandle(error.response.status)
        return Promise.reject(error.response)
    }
)

export default instance
